module.exports = __webpack_public_path__ + "static/media/Tilapia.49a93825.jpeg";